import {useCollection} from "@/app-autocomplete/hooks/useCollection.ts";
import {useCustomizedUrl} from "@/hooks/useCustomizedUrl.ts";
import {useTranslations} from "@/hooks/useTranslations.ts";
import {useAutocomplete} from "../providers/AutocompleteProvider.tsx";
import {Panel} from "./Panel.tsx";

export function Categories() {
    const {autocomplete} = useAutocomplete();
    const customizedUrl=useCustomizedUrl();
    const tc = useTranslations();
    const {items, source} = useCollection("categoriesPlugin")
    if (items.length === 0) return <></>;
    return (
        <>
            {items.length > 0 && (
                <Panel title={tc.categories}>
                    <ul className="aa-categories" {...autocomplete.getListProps({
                        source: source
                    })}>
                        {items.map((item, itemIndex) => (
                            <li key={itemIndex} className="aa-categories__item" {...autocomplete.getItemProps({
                                item: item,
                                source: source
                            })}>
                                <a href={`/${customizedUrl}/${item.slug}`}>
                                    {item.category_icon &&
                                        <img alt={item.category} loading="lazy"
                                             src={ "/userdata/dcshop/category_icon/" + item.category_icon} width={55}
                                             height={55} aria-hidden={true}/>}
                                    <span>{item.name}</span>
                                </a>
                            </li>
                        ))}
                    </ul>
                </Panel>
            )}
        </>
    );
}
